import orderProxySaga from '@/components/features/OrderProxy/redux/saga';

export default {
    orderProxySaga,
};
